// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"vendors-node_modules_pnpm_braintree_sanitize-url_5_0_0_node_modules_braintree_sanitize-url_di-dacf77": "87dc35508684764f","vendors-node_modules_pnpm_emotion_css_11_13_0_node_modules_emotion_css_create-instance_dist_e-5ec012": "a944d75127246381","vendors-node_modules_pnpm_react-quill_2_0_0_react-dom_18_2_0_react_18_2_0__react_18_2_0_node_-b68686": "2ca5dadeefa80149",}[chunkId] + ".chunk.css"
}